export default __webpack_public_path__ + "static/media/medal.464d2ce1.svg";